import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { LeadTimeTypeSchema, StoreUpdateLeadTimeRequestSchema } from '~/services/api/generated'
import type { LeadTimeType } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const BLANK_TO_NULL = ['day_before_cutoff_time', 'lead_time_hours', 'multiple_days_notice'] as const

// UpdateStoreLeadTimeRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [{ field: 'lead_time_type', options: LeadTimeTypeSchema.options }],
  blankToNull: BLANK_TO_NULL
})

const schema = StoreUpdateLeadTimeRequestSchema.strict()

interface StoredLeadTime {
  readonly lead_time_type: LeadTimeType
}

// UpdateStoreLeadTimeRequest: the stored lead time type applies when the request omits it.
export const StoreUpdateLeadTime = (
  context: StoredLeadTime | NoContext
): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    const storedType = 'lead_time_type' in context ? context.lead_time_type : undefined
    const effectiveType = value.lead_time_type ?? storedType
    const noticePresent = 'multiple_days_notice' in value
    const noticeRequired = value.lead_time_type === 'multiple_days'
    const noticeChecked = effectiveType === 'multiple_days' && (noticePresent || noticeRequired)
    const noticeInvalid = value.multiple_days_notice == null || value.multiple_days_notice < 1
    if (noticeChecked && noticeInvalid) {
      issues.addIssue({
        code: 'custom',
        message: 'multiple_days_notice_invalid',
        path: ['multiple_days_notice']
      })
    }
  })
